// extracted by mini-css-extract-plugin
export default {"card-primary-square-top":"CardPrimarySquareTop_card-primary-square-top__cBEzJ"};